import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

const styles: StyleRulesCallback = ({
  palette: {
    primary: { main }
  }
}) => ({
  back: {
    background: "white",
    border: `1px solid ${main}`,
    boxShadow: "none",
    color: main,
    padding: "0 32px"
  },
  container: {
    margin: "48px auto 32px",
    textAlign: "center"
  },
  img: {
    marginBottom: "10px",
    maxWidth: "68px"
  },
  subtitle: {
    maxWidth: "300px",
    margin: "10px auto 50px"
  },
  title: {
    fontWeight: 700
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
